import React, {useMemo} from 'react';
import ImageFigure from '../UI/Image/ImageFigure';

const RadioItem = ({
  checked,
  title,
  id,
  onHandleChange,
  icons,
  isSingle,
  children,
}) => {
  return (
    <div className={`radio-item ${isSingle ? 'radio-item--single' : ''}`}>
      <input
        id={id}
        className="form-radio"
        type="radio"
        name="form"
        value={id}
        checked={checked}
        onChange={onHandleChange}
      />
      <label
        htmlFor={id}
        className="radio-item__label"
      >
        <span className="payment-label">{title}</span>
        <span className="payment-icons">
          {icons.slice(0, 5).map((icon, i) => (
            <span key={icon}>
              <ImageFigure className="payment-cards" src={icon} alt="Payment_icons"/>
            </span>
          ))}
        </span>
      </label>
      { checked ? (
        <div className="form-radio__item-body">
          {children}
        </div>
      ) : null }
    </div>
  );
};

export default RadioItem;
